import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import { Button, Grid, Link, Image } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import http from "../services/httpService";
import {
  getDate,
  getDateTime,
  prospectDetailsPath,
  addReviewPath,
  investmentDetailsPath,
  addInvestorReviewPath,
  searchFilter,
  handleSort,
} from "../utils/varialbles";
import { useHistory } from "react-router-dom";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import staticFiles from "../services/staticApi";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Draggable from "react-draggable";
import toast from "react-hot-toast";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@material-ui/core/Box";

const useStyles = makeStyles({
  root: {
    width: "100%",
    backgroundColor: "#F5F7FA",
    padding: "7px",
  },
  circle: {
    borderRadius: "100%",
    background: "#3f51b5",
    color: "#fff",
  },
  outerColumn: {
    border: "1px solid #B5BCD8",
    marginTop: 10,
    padding: "30px",
    borderRadius: "4px",
  },
  reviewButton: {
    borderRadius: "20px",
    border: "1px solid #2835D5",
    opacity: 1,
    textAlign: "right",
  },
});
function PaperComponentBrowseImage(props) {
  return (
    <Draggable
      handle="#draggable-dialog-titleBrowseImage"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

function ProspectSatisfaction() {
  const location = useLocation();
  let history = useHistory();
  const classes = useStyles();
  const [showWindow, setShowWindow] = useState(false);
  const [satisfactionScore, setSatisfactionScore] = useState([]);
  const [overAllScore, setoverAllScore] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const fileInputRef = useRef(null);
  const [openBrowseImage, setopenBrowseImage] = useState(false);
  const [proofSrc, setProofSrc] = React.useState({});
  const [feedback, setFeedback] = useState([]);
  const [showFeedback, setShowFeedback] = useState(false);

  const [columns, setColumns] = useState([
    {
      headerName: "Questions",
      id: "question",
      show: true,
      minWidth: 150,
      // type: "link",
    },
    {
      headerName: "Answers",
      id: "answer",
      show: true,
      minWidth: 150,
    },
    {
      headerName: "Date",
      id: "createddt",
      show: true,
      minWidth: 150,
      type: "date",
    },
  ]);

  const myparam = location.state;

  const handleFileUpload = (event) => {
    event.preventDefault();
    const formData = new FormData();
    handleBrowseImageClose();
    formData.append(
      "screenshot",
      event.target.files[0],
      event.target.files[0].name
    );
    http
      .patch("/update_prospect_satisfaction/" + proofSrc.id + "/", formData)
      .then((response) => {
        if (response.data.id) {
          toast.success("Screenshot Uploaded Successfully..!");
          handleReload();
        } else {
          toast.error("Screenshot Upload Failed..!");
        }
      })
      .catch((err) => {
        toast.error("Screenshot Upload Failed..!");
      });
  };
  const openPopup = (e, record) => {
    setProofSrc(record);
    setopenBrowseImage(true);
  };

  const handleReload = () => {
    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      var cust_id = myparam.cust__id || myparam.customer_id;
      http
        .get("/prospect_satisfaction/" + cust_id)
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
          ) {
            setSatisfactionScore(res.data.data);
            setShowWindow(true);
          }
          if (res && res.data && res.data.Overall_Score) {
            setoverAllScore(res.data.Overall_Score);
          }
        })
        .catch((err) => { });
    } else {
      history.goBack();
    }

    if (myparam && (myparam.cust__id || myparam.customer_id)) {
      var cust_id = myparam.cust__id || myparam.customer_id;
      http
        .get("/feedback/" + cust_id)
        .then((res) => {
          if (
            res &&
            res.data &&
            res.data.data &&
            Array.isArray(res.data.data) &&
            res.data.data.length > 0
          ) {
            setFeedback(res.data.data);
            setShowFeedback(true);
          } else {
            toast.error("No Feedback Found");
          }
        })
        .catch((err) => { });
    } else {
      history.goBack();
    }
  };

  const handleBrowseImageClose = () => {
    setopenBrowseImage(false);
  };

  useEffect(() => {
    handleReload();
  }, []);
  const addReview = (e) => {
    e.preventDefault();

    if (myparam && myparam.cust__id) {
      history.push({
        pathname: addReviewPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: addInvestorReviewPath,
        state: myparam,
      });
    }
  };
  const gotoProspectDetails = (e) => {
    e.preventDefault();
    if (myparam && myparam.cust__id) {
      history.push({
        pathname: prospectDetailsPath,
        state: myparam,
      });
    } else if (myparam && myparam.customer_id) {
      history.push({
        pathname: investmentDetailsPath,
        state: myparam,
      });
    }
  };

  return (
    <Grid container style={{ marginBottom: "50px" }}>
      <Paper className={classes.root}>
        <Grid container>
          <Grid item xs={12} sm={6} md={3}>
            <Button
              name="Overview"
              variant="contained"
              color="primary"
              onClick={gotoProspectDetails}
            >
              Overview
            </Button>
            {/* <Button name="Investor Service" variant="text" color="primary" onClick={gotoProspectDetails}>Investor Service</Button> */}
            {/* <Button name="Portfolio" variant="text" color="primary" onClick={gotoProspectDetails}>Portfolio</Button> */}
          </Grid>
        </Grid>
      </Paper>
      <Grid container style={{ marginTop: 30 }}>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="outlined"
            color="default"
            startIcon={<ArrowBackIosIcon />}
            onClick={gotoProspectDetails}
          >
            Back
          </Button>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Typography color="textPrimary" variant="h5">
            {myparam && myparam.cust__id ? "Prospect " : "Investor "}{" "}
            Satisfaction
          </Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={2} xl={1} align="right">
          <Button variant="contained" color="primary" onClick={addReview}>
            Add Review
          </Button>
        </Grid>
      </Grid>
      <Grid container style={{ marginTop: 50 }}>
        <Grid item xs={12} sm={12} md={12}>
          <Typography variant="h5" color="textPrimary">
            Overall Score -{" "}
            <span style={{ color: "#f50057" }}>
              {overAllScore ? overAllScore : "N/A"}
            </span>
          </Typography>
        </Grid>
      </Grid>
      {satisfactionScore.map((row, inx) => {
        return (
          <Grid container style={{ marginTop: 20 }}>
            {row.platform_name ? (
              <Grid item xs={12}>
                <Typography variant="h6">{row.platform_name}</Typography>
              </Grid>
            ) : (
              ""
            )}
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              className={classes.outerColumn}
              key={inx + "Score"}
            >
              <Grid container>
                <Grid item xs={12} sm={1} md={1}>
                  <Typography variant="h4" color="textPrimary">
                    {row.rating ? row.rating : "N/A"}
                  </Typography>
                </Grid>
                {row.url ? (
                  <Grid
                    item
                    xs={12}
                    sm={10}
                    md={10}
                    style={{ verticalAlign: "bottom" }}
                  >
                    <Link
                      href={row.url}
                      underline="always"
                      style={{ marginLeft: "10px" }}
                      target="_blank"
                    >
                      {row.url}
                    </Link>
                  </Grid>
                ) : (
                  <Grid
                    item
                    xs={12}
                    sm={10}
                    md={10}
                    style={{ verticalAlign: "bottom" }}
                  ></Grid>
                )}
                <Grid item xs={12} sm={1} md={1} justify="flex-end">
                  <Typography variant="body2" color="textPrimary">
                    {getDate(row.review_updated_at)}
                  </Typography>
                </Grid>
              </Grid>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} style={{ marginTop: 20 }}>
                  <Typography variant="body1" color="textPrimary">
                    <span style={{ fontWeight: 700 }}>Tags:</span>{" "}
                    {row.tags ? row.tags : "N/A"}
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} style={{ marginTop: 20 }}>
                  <Typography variant="body1" color="textPrimary">
                    <span style={{ fontWeight: 700 }}>Comment:</span>{" "}
                    {row.comment ? row.comment : "N/A"}
                  </Typography>
                </Grid>
              </Grid>
              {row.screenshot ? (
                <Grid container style={{ marginTop: 20 }}>
                  {" "}
                  <Paper variant="outlined">
                    <img
                      src={staticFiles + row.screenshot}
                      style={{ maxHeight: "200px", maxWidth: "300px" }}
                    />
                  </Paper>
                </Grid>
              ) : (
                <Grid container justifyContent="flex-end" alignItems="flex-end">
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    md={8}
                    lg={9}
                    xl={10}
                    style={{ marginTop: 20 }}
                  ></Grid>
                  <Grid item xs={12} sm={4} md={4} lg={3} xl={2}>
                    <Button
                      startIcon={<AddCircleOutlineIcon />}
                      variant="outlined"
                      className={classes.reviewButton}
                      color="primary"
                      onClick={(e) => openPopup(e, row)}
                    >
                      Add screenshot{" "}
                    </Button>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        );
      })}
      <Dialog
        open={openBrowseImage}
        onClose={handleBrowseImageClose}
        PaperComponent={PaperComponentBrowseImage}
        aria-labelledby="draggable-dialog-titleBrowseImage"
        maxWidth="xs"
      // style={{
      //   top: "320px",
      //   left: "861px",
      //   width: "483px",
      //   height: "440px"
      // }}
      >
        <DialogTitle
          style={{ cursor: "move" }}
          id="draggable-dialog-titleBrowseImage"
        ></DialogTitle>
        <DialogContent style={{ paddingBottom: 30, width: 150, height: 100 }}>
          <Grid item xs={12} align="center" style={{ marginTop: "20%" }}>
            <input
              ref={fileInputRef}
              onChange={handleFileUpload}
              type="file"
              style={{ display: "none" }}
              multiple={false}
            />
            <Button
              onClick={() => fileInputRef.current.click()}
              variant="contained"
              color="primary"
              style={{ paddingLeft: 30, paddingRight: 30 }}
            >
              Browse
            </Button>
          </Grid>
        </DialogContent>
      </Dialog>

      <TableContainer
        component={Paper}
        sx={{ minWidth: 650, marginTop: "20px" }}
        style={showFeedback ? { display: "block" } : { display: "none" }}
      >
        <Table
          sx={{ minWidth: 650, marginTop: "15px" }}
          aria-label="simple table"
        >
          <TableHead>
            <Box sx={{ marginLeft: "10px" }}>
              <Typography variant="h4" id="tableTitle" component="div">
                Feedback Responses
              </Typography>
            </Box>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.id} align={col.align}>
                  {col.headerName}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {feedback.map((item) => {
              return (
                <TableRow>
                  {columns.map((cols) => {
                    const value = item[cols.id];
                    // (item);
                    return (
                      <TableCell>
                        {cols.type === "date"
                          ? getDateTime(value)
                          : value
                            ? value
                            : "N/A"}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Grid>
  );
}

export default ProspectSatisfaction;
